<template>
  <div class="ic-form__agreements">
    <h3 v-if="header">{{ $t(header) }}</h3>
    <IcFormRowWrapper :id="name" :name="name" :labelWidth="0" :controlWidth="12" :showSingleError="true" rowElement="IcFormRow">
      <template slot-scope="{validator}">
        <!-- <div>
          (
          <a @click="showText = 1" v-if="showText != 1">{{$t('forms_agreement_show_text')}}</a>
          <a @click="showText = 0" v-if="showText == 1">{{$t('forms_agreement_hide_text')}}</a>
          )
        </div>-->

        <div class="mbm" v-if="text" v-html="$t(text)" style="padding-left: 25px;"></div>
        
        <ic-checkbox v-if="is_visible === true" :id="name" v-model="value" val="1"
          @input="emitInput($event, validator)" :modal="modal" modalId="#agreementsModal">
          <span class="small" v-html="$t(label)"></span>
        </ic-checkbox>
        <div v-if="is_visible === false" v-html="$t(label)" class="pt-4"></div>
        <div  v-if="modal"><a href="#" data-bs-toggle="modal" data-bs-target="#agreementsModal" class="h5"><span v-html="$t('ic_wiecej_info_rodo')"></span></a></div>
      </template>
    </IcFormRowWrapper>
    <div v-if="modal">
      <div class="modal fade" id="agreementsModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="agreementsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="h5"> {{$t('modal_agreement_header_label')}} </h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <slot></slot>
              <div v-html="$t(content)"></div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{$t('zamknij')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IcCheckbox from "@/components/ic-common/form/controls/Checkbox";
import { emitInput } from "./mixins";

export default {
  name: "IcFormAgreements",
  props: {
    is_visible: {
      default: true
    },
    value: {
      default: false
    },
    name:{
      type: String,
      default: "agreement"
    },
    header: {
      type: [Boolean, String],
      default: "label_agreement"
    },
    label: {
      type: String,
      default: "label_agreement_checkbox"
    },
    text: {
      type: [Boolean, String],
      default: "form_agreement_k"
    },
    content: {
      type: [Boolean, String],
    },
    modal: {
      type:Boolean,
      default:false
    }    
  },
  data() {
    return {
      agreement: this.value,
      showText: 1
    };
  },
  methods: {
    emitInput
  },
  components: {
    IcCheckbox
  }
};
</script>

<style></style>
